"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const button_1 = require("primereact/button");
const overlaypanel_1 = require("primereact/overlaypanel");
const react_i18next_1 = require("react-i18next");
const FilterPanel_1 = require("./FilterPanel");
const FilterButton = ({ filters, values, onFilterChange, buttonLabel = 'Filtros', }) => {
    const op = (0, react_1.useRef)(null);
    const [localValues, setLocalValues] = (0, react_1.useState)(values);
    const { t } = (0, react_i18next_1.useTranslation)();
    (0, react_1.useEffect)(() => {
        setLocalValues(values);
    }, [values]);
    const resolvedFilters = typeof filters === 'function' ? filters(localValues) : filters;
    const handleChange = (key, selectedValues) => {
        setLocalValues((prev) => ({ ...prev, [key]: selectedValues }));
    };
    const handleApply = () => {
        onFilterChange(localValues);
        op.current?.hide();
    };
    const handleClear = () => {
        const cleared = {};
        resolvedFilters.forEach((f) => (cleared[f.key] = []));
        setLocalValues(cleared);
        onFilterChange(cleared);
        op.current?.hide();
    };
    const activeCount = Object.values(values).reduce((acc, v) => acc + (v?.length || 0), 0);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "relative inline-block", children: [(0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-filter", label: buttonLabel, className: "w-10 h-10 p-button-rounded p-button-outlined hover:bg-surface-200 transition-all relative rounded-3xl border border-gray-300 bg-white", onClick: (e) => op.current?.toggle(e) }), activeCount > 0 && ((0, jsx_runtime_1.jsx)("span", { className: "absolute -top-1 -right-1 bg-customBlue text-white text-xs rounded-full w-5 h-5 flex items-center justify-center", children: activeCount })), (0, jsx_runtime_1.jsx)(overlaypanel_1.OverlayPanel, { ref: op, dismissable: true, className: "p-4 rounded-2xl shadow-xl border border-surface-200 bg-white w-100", children: (0, jsx_runtime_1.jsx)(FilterPanel_1.FilterPanel, { filters: resolvedFilters, localValues: localValues, onChange: handleChange, onApply: handleApply, onClear: handleClear }) })] }));
};
exports.FilterButton = FilterButton;
